// extracted by mini-css-extract-plugin
export default {"container":"orders-card_container__Yo6nP","ingredients":"orders-card_ingredients__RmLIX","wrapper":"orders-card_wrapper__4e2PW","status":"orders-card_status__QwzAT"};